import React, { useEffect, useState } from 'react'
import mapboxgl from 'mapbox-gl'
import 'mapbox-gl/dist/mapbox-gl.css'
import { InteractionToggle } from './interactionToggle.js'
import { ActivationButton } from './activationButton.js'

import './style.scss'

function AnimatedMap(props) {
  const [mapObject, setMapObject] = useState(null)

  const setInteractivity = enabled => {
    if (!mapObject) return

    if (enabled) {
      mapObject.scrollZoom.enable()
      mapObject.boxZoom.enable()
      mapObject.dragRotate.enable()
      mapObject.dragPan.enable()
      mapObject.keyboard.enable()
      mapObject.doubleClickZoom.enable()
      mapObject.touchZoomRotate.enable()
    } else {
      mapObject.scrollZoom.disable()
      mapObject.boxZoom.disable()
      mapObject.dragRotate.disable()
      mapObject.dragPan.disable()
      mapObject.keyboard.disable()
      mapObject.doubleClickZoom.disable()
      mapObject.touchZoomRotate.disable()
    }
  }

  useEffect(() => {
    mapboxgl.accessToken = 'pk.eyJ1IjoidGEtaW50ZXJha3RpdiIsImEiOiJja3BmaXZzNmgyN3pvMnZubDl0dXE5bDF3In0.T0pF-IOtIse_uJ-NsodAAg';
    const map = new mapboxgl.Map({
      container: 'map',
      style: 'mapbox://styles/mapbox/light-v10',
      center: [8.5401, 47.3746],
      zoom: 10,
      minZoom: 8,
      maxZoom: 18,
      interactive: true
    })

    // Return map object
    if ('getMapObject' in map) props.getMapObject(map)

    // Add controls
    const navigationControl = new mapboxgl.NavigationControl({
      showCompass: false
    })

    map.addControl(navigationControl, 'top-right')

    map.activateMap = function() {
      this.scrollZoom.enable()
      this.boxZoom.enable()
      this.dragRotate.enable()
      this.dragPan.enable()
      this.keyboard.enable()
      this.doubleClickZoom.enable()
      this.touchZoomRotate.enable()
    }

    map.deactivateMap = function() {
      this.scrollZoom.disable()
      this.boxZoom.disable()
      this.dragRotate.disable()
      this.dragPan.disable()
      this.keyboard.disable()
      this.doubleClickZoom.disable()
      this.touchZoomRotate.disable()
    }

    map.deactivateMap()

    const interactionControl = new InteractionToggle(map, [
      'Karte aktivieren',
      'Scrollen aktivieren'
    ])
    map.addControl(interactionControl, 'top-right')

    setInteractivity(false)

    setMapObject(map)

    // Initial adjustments
    map.once('load', () => {

          map.addSource('data', {
            type: 'geojson',
            data: require('./data.geojson')
          })

          map.addLayer({
            id: 'data',
            type: 'circle',
            source: 'data',
            paint: {
              'circle-radius': {
                base: 1,
                stops: [
                  [8, 5],
                  [18, 15]
                ]
              },
              'circle-color': '#378EBD',
              'circle-stroke-width': 1,
              'circle-stroke-color': '#fff'
            }
          })

          // Add Popup
          map.on('click', 'data', e => {
            if (e && e.features && e.features[0].properties) {
              const p = e.features[0].properties
              props.onClick(p)
            }
          })

          // Fit Map
          map.fitBounds(
            [
              [8.510, 47.340],
              [8.589, 47.415]
            ],
            { duration: 0 }
          )

          // On Load Callback
          if (props.onLoad) {
            props.onLoad()
          }
        })
  }, [])

  return (
    <>
      {mapObject && (
        <div className='activateDesktop'>
          <ActivationButton
            activate={() => mapObject.activateMap()}
            deactivate={() => mapObject.deactivateMap()}
            initialState={null}
            buttonText={['Karte aktivieren', 'Scrollen aktivieren']}
            icons={['moving.svg', 'scrolling.svg']}
          />
        </div>
      )}
      <div id='map'>{props.children}</div>
    </>
  )
}

export default AnimatedMap
